import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm } from "redux-form";
import LocaleStrings from "Languages";



class ContacteventifyModal extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      loading: true,
      btnLoading:false
    };
  }


 
  closeModals = () => {
    this.props.onClose();
  };
 


  render() {
    let { session, pageid, section } = this.props;
    return (
      <Modal
        show={this.props.isOpen}
        onHide={this.closeModals}
        className=""
        dialogClassName="contact-eventify-modal"
      >
        <Modal.Header >
          <Modal.Title><div className="title-modal">{LocaleStrings.accountsetting_billingdetails_contacteventify_modaltitle}</div></Modal.Title>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={this.closeModals}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
            <div className="contact-eventify-modal-text">
                {LocaleStrings.accountsetting_billingdetails_contacteventify_modalbodytext}
            </div>
        </Modal.Body>
        <Modal.Footer>
        <div>
          <div className="pull-left h-100 vertical-align-center">
              {/* <div className="custom-text1-primary-medium">
                {LocaleStrings.accountsetting_billingdetails_headerleft}
              </div> */}
          </div>
          <div className="pull-right h-100 vertical-align-center" style={{marginLeft:'auto'}}>
          <Button variant="secondary" onClick={this.closeModals}>
            {LocaleStrings.accountsetting_billingdetails_contacteventify_modalclose}
          </Button>
        
          </div>
        </div>

        

        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}
export default connect(mapStateToProps, {
})(
  reduxForm({
    form: "ContacteventifyModalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ContacteventifyModal)
);